import {filter, lazy} from './lang.js';
import {doc} from './documentation.js';
import {atranspose} from './utils.js';

doc(
    "invert",
    {
        octaves: "",
    },
    "inverts notes by an octave (high notes go down/low notes up)");
export const invert = (octaves=1) => {
  let sum = 0.0;
  let ct = 0;
  return (... args) => {
    let [stepData] = args;
    if (!stepData) {
      return filter(false);
    }
    sum += stepData.transpose;
    ct++;
    let _octaves = lazy(octaves, ...args);
    if (stepData.transpose <= sum/ct) {
        return atranspose(12*_octaves)(...args);
    } else {
        return atranspose(-12*_octaves)(...args);
    }   
  };
};
